var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / calendar-days"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 4V1.33333C4.83333 1.05719 5.05719 0.833333 5.33333 0.833333C5.60948 0.833333 5.83333 1.05719 5.83333 1.33333V4C5.83333 4.27614 5.60948 4.5 5.33333 4.5C5.05719 4.5 4.83333 4.27614 4.83333 4Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 4V1.33333C10.1667 1.05719 10.3905 0.833333 10.6667 0.833333C10.9428 0.833333 11.1667 1.05719 11.1667 1.33333V4C11.1667 4.27614 10.9428 4.5 10.6667 4.5C10.3905 4.5 10.1667 4.27614 10.1667 4Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4C13.5 3.53976 13.1269 3.16667 12.6667 3.16667H3.33333C2.8731 3.16667 2.5 3.53976 2.5 4V13.3333C2.5 13.7936 2.8731 14.1667 3.33333 14.1667H12.6667C13.1269 14.1667 13.5 13.7936 13.5 13.3333V4ZM14.5 13.3333C14.5 14.3459 13.6792 15.1667 12.6667 15.1667H3.33333C2.32081 15.1667 1.5 14.3459 1.5 13.3333V4C1.5 2.98748 2.32081 2.16667 3.33333 2.16667H12.6667C13.6792 2.16667 14.5 2.98748 14.5 4V13.3333Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.16667C14.2761 6.16667 14.5 6.39052 14.5 6.66667C14.5 6.94281 14.2761 7.16667 14 7.16667H2C1.72386 7.16667 1.5 6.94281 1.5 6.66667C1.5 6.39052 1.72386 6.16667 2 6.16667H14Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33984 8.83333C5.61599 8.83333 5.83984 9.05719 5.83984 9.33333C5.83984 9.60948 5.61599 9.83333 5.33984 9.83333H5.33333C5.05719 9.83333 4.83333 9.60948 4.83333 9.33333C4.83333 9.05719 5.05719 8.83333 5.33333 8.83333H5.33984Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00651 8.83333C8.28265 8.83333 8.50651 9.05719 8.50651 9.33333C8.50651 9.60948 8.28265 9.83333 8.00651 9.83333H8C7.72386 9.83333 7.5 9.60948 7.5 9.33333C7.5 9.05719 7.72386 8.83333 8 8.83333H8.00651Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6732 8.83333C10.9493 8.83333 11.1732 9.05719 11.1732 9.33333C11.1732 9.60948 10.9493 9.83333 10.6732 9.83333H10.6667C10.3905 9.83333 10.1667 9.60948 10.1667 9.33333C10.1667 9.05719 10.3905 8.83333 10.6667 8.83333H10.6732Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33984 11.5C5.61599 11.5 5.83984 11.7239 5.83984 12C5.83984 12.2761 5.61599 12.5 5.33984 12.5H5.33333C5.05719 12.5 4.83333 12.2761 4.83333 12C4.83333 11.7239 5.05719 11.5 5.33333 11.5H5.33984Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00651 11.5C8.28265 11.5 8.50651 11.7239 8.50651 12C8.50651 12.2761 8.28265 12.5 8.00651 12.5H8C7.72386 12.5 7.5 12.2761 7.5 12C7.5 11.7239 7.72386 11.5 8 11.5H8.00651Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6732 11.5C10.9493 11.5 11.1732 11.7239 11.1732 12C11.1732 12.2761 10.9493 12.5 10.6732 12.5H10.6667C10.3905 12.5 10.1667 12.2761 10.1667 12C10.1667 11.7239 10.3905 11.5 10.6667 11.5H10.6732Z",
    fill: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDays);
export default __webpack_public_path__ + "static/media/calendar-days.41cb684058bd249ec7e139f280e8ba89.svg";
export { ForwardRef as ReactComponent };